// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomItemOrder
 */
export interface ClassroomItemOrder {
    /**
     * 
     * @type {string}
     * @memberof ClassroomItemOrder
     */
    item: string;
    /**
     * 
     * @type {number}
     * @memberof ClassroomItemOrder
     */
    order: number;
}

export function ClassroomItemOrderFromJSON(json: any): ClassroomItemOrder {
    return {
        'item': json['item'],
        'order': json['order'],
    };
}

export function ClassroomItemOrderToJSON(value?: ClassroomItemOrder): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'item': value.item,
        'order': value.order,
    };
}


